import React from 'react';

// third-party
import ReactPaginate from 'react-paginate';

function PaginatedItems({ onCurrentItemsChange, initialPage, pageCount }) {

    return (
        <>
            <ReactPaginate
                forcePage={initialPage}
                breakLabel="..."
                nextLabel={<i className="ri-arrow-drop-right-line"></i>}
                onPageChange={onCurrentItemsChange}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel={<i className="ri-arrow-drop-left-line"></i>}
                renderOnZeroPageCount={null}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName=""
                previousLinkClassName="page-link"
                nextClassName=""
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="edu-pagination"
                activeClassName="active"
            />
        </>
    );
}

export default PaginatedItems;

